import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { IPomReportingHistoryEntryModel } from "../../models/reportings/pom-reporting-history.model";
import { PomQueryKeys } from "../../pom-query-keys";
import getInstance from "../../../utils/rest";

const fetchReportingHistory = async (
  contractNo: string,
  reportingNo: number
): Promise<IPomReportingHistoryEntryModel[]> => {
  const result = await getInstance().get<IPomReportingHistoryEntryModel[]>(
    `${RestEndpoints.PomReportings}/${contractNo}/${reportingNo}/history`
  );
  return result.data;
};

/**
 * History of every position in a reporting, fetched in one request. Consumers filter the
 * result by `positionNo` — because all expanded position rows share this query key, React
 * Query deduplicates them into a single call instead of one per position.
 */
export const useGetReportingHistoryQuery = (
  contractNo: string | undefined,
  reportingNo: number | undefined,
  enabled: boolean = false
) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetReportingHistory, contractNo, reportingNo],
    queryFn: () => fetchReportingHistory(contractNo as string, reportingNo as number),
    staleTime: 60_000, // BC is authoritative and may change outside the portal
    enabled: enabled && !!contractNo && reportingNo !== undefined,
  });
};
